<section class="tax-invoice-form-wrapper">
  <div class="box-container">
    <!-- topic -->
    <div class="tax-invoice-topic">
      <!-- desktop heading  -->
      <div
        class="tax-invoice-topic__heading tax-invoice-topic__heading--desktop color-gray"
        [innerHtml]="'TAX_INVOICE.FORM.HEADING' | translate"
      ></div>

      <!-- tablet heading  -->
      <div
        class="tax-invoice-topic__heading tax-invoice-topic__heading--tablet color-gray"
        [innerHtml]="'TAX_INVOICE.FORM.HEADING_TABLET' | translate"
      ></div>

      <!-- mobile heading  -->
      <div
        class="tax-invoice-topic__heading tax-invoice-topic__heading--mobile color-gray"
        [innerHtml]="'TAX_INVOICE.FORM.HEADING_MOBILE' | translate"
      ></div>

      <div
        *ngIf="showFormPattern !== taxInvoiceTabEnum.ElectronicTaxInvoice"
        class="tax-invoice-topic__heading-detail"
        >{{ 'TAX_INVOICE.FORM.DETAIL' | translate }}</div
      >
      <div
        *ngIf="showFormPattern === taxInvoiceTabEnum.ElectronicTaxInvoice"
        class="tax-invoice-topic__heading-detail"
        >{{ 'TAX_INVOICE.FORM.DETAIL_FOR_E_TAX' | translate }}</div
      >
    </div>

    <!-- content -->
    <div class="box">
      <div class="form-tab">
        <div
          class="text-header-form mg-right"
          [ngClass]="{ active: showFormPattern === taxInvoiceTabEnum.FullTaxInvoice }"
          (click)="displayFormFormat(1)"
        >
          {{ 'TAX_INVOICE.FORM.FORM_TAX_INVOICE_1' | translate }}</div
        >
        <div
          class="text-header-form mg-right"
          [ngClass]="{ active: showFormPattern === taxInvoiceTabEnum.AbbreviatedTaxInvoice }"
          (click)="displayFormFormat(2)"
        >
          {{ 'TAX_INVOICE.FORM.FORM_TAX_INVOICE_2' | translate }}</div
        >
        <div
          class="text-header-form"
          [ngClass]="{ active: showFormPattern === taxInvoiceTabEnum.ElectronicTaxInvoice }"
          (click)="displayFormFormat(3)"
        >
          {{ 'TAX_INVOICE.FORM.FORM_TAX_INVOICE_3' | translate }}</div
        >
      </div>

      <div class="tab-desktop">
        <picture *ngIf="showFormPattern === taxInvoiceTabEnum.FullTaxInvoice">
          <source
            srcset="{{ translate.currentLang === 'th' ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_desktop_slide_1_th_v2.webp' : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_desktop_slide_1_en_v2.webp' }}"
            type="image/webp"
          />
          <img
            src="{{
              translate.currentLang === 'th'
                ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_desktop_slide_1_th_v2.png'
                : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_desktop_slide_1_en_v2.png'
            }}"
            width="100%"
            height="auto"
            alt="วิธีทำใบกำกับภาษี"
            title="วิธีทำใบกำกับภาษี"
            loading="lazy"
          />
        </picture>

        <picture *ngIf="showFormPattern === taxInvoiceTabEnum.AbbreviatedTaxInvoice">
          <source
            srcset="{{ translate.currentLang === 'th' ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_desktop_slide_2_th.webp' : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_desktop_slide_2_en.webp'}}"
            type="image/webp"
          />
          <source
            srcset="{{ translate.currentLang === 'th' ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_desktop_slide_2_th.png' : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_desktop_slide_2_en.png'}}"
            type="image/png"
          />
          <img
            src="{{
              translate.currentLang === 'th'
                ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_desktop_slide_2_th.png'
                : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_desktop_slide_2_en.png'
            }}"
            width="100%"
            height="auto"
            alt="วิธีทำใบกำกับภาษีอย่างย่อ"
            title="วิธีทำใบกำกับภาษีอย่างย่อ"
            loading="lazy"
          />
        </picture>

        <picture *ngIf="showFormPattern === taxInvoiceTabEnum.ElectronicTaxInvoice">
          <source
            srcset="{{ translate.currentLang === 'th' ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/e_tax_invoice_by_email_desktop_th_v1.webp' : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/e_tax_invoice_by_email_desktop_en_v1.webp'}}"
            type="image/webp"
          />
          <source
            srcset="{{ translate.currentLang === 'th' ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/e_tax_invoice_by_email_desktop_th_v1.png' : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/e_tax_invoice_by_email_desktop_en_v1.png'}}"
            type="image/png"
          />
          <img
            src="{{
              translate.currentLang === 'th'
                ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/e_tax_invoice_by_email_desktop_th_v1.png'
                : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/e_tax_invoice_by_email_desktop_en_v1.png'
            }}"
            width="100%"
            height="auto"
            alt="ใบกำกับภาษีอิเล็กทรอนิกส์"
            title="ใบกำกับภาษีอิเล็กทรอนิกส์"
            loading="lazy"
          />
        </picture>
      </div>

      <div class="tab-mobile">
        <picture *ngIf="showFormPattern === taxInvoiceTabEnum.FullTaxInvoice">
          <source
            srcset="{{ translate.currentLang === 'th' ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_mobile_slide_1_th.webp' : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_mobile_slide_1_en_v2.webp' }}"
            type="image/webp"
          />
          <img
            src="{{
              translate.currentLang === 'th'
                ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_mobile_slide_1_th.png'
                : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_mobile_slide_1_en_v2.png'
            }}"
            width="100%"
            height="auto"
            alt="วิธีทำใบกำกับภาษี"
            title="วิธีทำใบกำกับภาษี"
            loading="lazy"
          />
        </picture>

        <picture *ngIf="showFormPattern === taxInvoiceTabEnum.AbbreviatedTaxInvoice">
          <source
            srcset="{{ translate.currentLang === 'th' ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_mobile_slide_2_th.webp' : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_mobile_slide_2_en.webp'}}"
            type="image/webp"
          />
          <source
            srcset="{{ translate.currentLang === 'th' ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_mobile_slide_2_th.png' : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_mobile_slide_2_en.png'}}"
            type="image/png"
          />
          <img
            src="{{
              translate.currentLang === 'th'
                ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_mobile_slide_2_th.png'
                : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/section_3_mobile_slide_2_en.png'
            }}"
            width="100%"
            height="auto"
            alt="วิธีทำใบกำกับภาษีอย่างย่อ"
            title="วิธีทำใบกำกับภาษีอย่างย่อ"
            loading="lazy"
          />
        </picture>

        <picture *ngIf="showFormPattern === taxInvoiceTabEnum.ElectronicTaxInvoice">
          <source
            srcset="{{ translate.currentLang === 'th' ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/e_tax_invoice_by_email_mobile_th_v1.webp' : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/e_tax_invoice_by_email_mobile_en_v1.webp'}}"
            type="image/webp"
          />
          <source
            srcset="{{ translate.currentLang === 'th' ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/e_tax_invoice_by_email_mobile_th_v1.png' : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/e_tax_invoice_by_email_mobile_en_v1.png'}}"
            type="image/png"
          />
          <img
            src="{{
              translate.currentLang === 'th'
                ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/e_tax_invoice_by_email_mobile_th_v1.png'
                : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section3/e_tax_invoice_by_email_mobile_en_v1.png'
            }}"
            width="100%"
            height="auto"
            alt="ใบกำกับภาษีอิเล็กทรอนิกส์"
            title="ใบกำกับภาษีอิเล็กทรอนิกส์"
            loading="lazy"
          />
        </picture>
      </div>
    </div>
  </div>
</section>
